import React from "react";

// ─────────────────────────────────────────────
// Toggle this to false to hide the watermark
// across every page that imports it.
// ─────────────────────────────────────────────
const SHOW_WATERMARK = true;

const Watermark = () => {
    if (!SHOW_WATERMARK) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                pointerEvents: "none",
                zIndex: 9999,
            }}
        >
            <span
                style={{
                    fontSize: "clamp(2.5rem, 8vw, 6rem)",
                    fontWeight: 900,
                    color: "rgba(220, 38, 38, 0.18)",
                    textTransform: "uppercase",
                    letterSpacing: "0.1em",
                    whiteSpace: "nowrap",
                    transform: "rotate(-35deg)",
                    userSelect: "none",
                    fontFamily: "sans-serif",
                }}
            >
                TESTING ONLY
            </span>
        </div>
    );
};

export default Watermark;